import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 24 27" fill={color}>
    <g id="Page-1">
      <g id="_x30_02D-Connected-Home-Parental-Control" transform="translate(-201.000000, -963.000000)">
        <g id="SHS-Icons_user" transform="translate(202.000000, 964.000000)">
          <path id="Path" style={{ fill: color }} d="M7,18.7c0-2.5,1.5-4.1,4-4.1c2.4,0,4,1.6,4,4.1H7z" />
          <path
            id="Path_1_"
            style={{ fill: color }}
            d="M13.6,10.6c0,0.5-0.2,1.1-0.4,1.5c-0.3,0.4-0.7,0.8-1.2,1c-0.5,0.2-1,0.3-1.5,0.2
				c-0.5-0.1-1-0.4-1.4-0.7c-0.4-0.4-0.6-0.9-0.7-1.4c-0.1-0.5,0-1.1,0.2-1.6s0.5-0.9,1-1.2C9.9,8,10.4,7.9,11,7.9
				c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.9,0.6c0.2,0.3,0.4,0.6,0.6,0.9C13.6,9.9,13.6,10.2,13.6,10.6z"
          />
          <path
            id="Path_2_"
            style={{ fill: 'none', stroke: color, strokeWidth: '1.4' }}
            d="M11,25.3C0.5,25.3,0.4,7.6,0.4,6.9c0-0.2,0.1-0.4,0.1-0.5C0.6,6.2,0.7,6,0.9,5.9l9.6-5.4
				c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.5,0.1L21,5.9c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.4,0.1,0.5
				C21.6,7.6,21.5,25.3,11,25.3L11,25.3z"
          />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/SHS_Icons_user.js